import {useCallback, useEffect, useState} from "react";
import {API, Endpoints} from "@brg/api";


export const useGetCatalogs = (service: string, userId: string | null, allowNoProfile?: boolean, disabled?: boolean, lang: string = 'en'
) => {

    const [catalogs, setCatalogs] = useState<any>(undefined);
    const [subCollections, setSubCollections] = useState<any[]>([]);
    const [isLoadingCatalogs, setIsLoadingCatalogs] = useState<boolean>(false);
    const [error, setError] = useState<boolean>(false);

    const fetchCatalogs = useCallback(() => {
        if (disabled) {
            return;
        }
        setIsLoadingCatalogs(true);
        const apiRequest = userId
            ? API.request()
                .endpoint(Endpoints.cardsMnePw)
                .url('/api/Collection/GetCatalogs')
                .addQuery('service', service)
                .addQuery('userId', userId)
                .addQuery('exceptForSelectors', 'true')
                .get()
            : API.request()
                .endpoint(Endpoints.cardsMnePw)
                .url('/api/Collection/GetCatalogs')
                .addQuery('service', service)
                .addQuery('exceptForSelectors', 'true')
                .get()
        apiRequest
            .send()
            .then((r) => r.json())
            .then((r) => {
                setIsLoadingCatalogs(false);
                setCatalogs(r)
                const allSubCollections = r?.flatMap((catalog: any) => 
                    catalog.subCollections?.map((sub: any) => ({
                        ...sub,
                        catalogId: catalog.cardCollectionId
                    })) || []);
                setSubCollections(allSubCollections)
            })
            .catch((e) => {
                setIsLoadingCatalogs(false);
                setError(true)
            });
    }, [userId, service])

    useEffect(() => {
        if ((userId || allowNoProfile) && service) {
            fetchCatalogs()
        }
    }, [userId, service, allowNoProfile, fetchCatalogs])

    return {
        catalogs: API.toLang(catalogs, lang) as any,
        subCollections: API.toLang(subCollections, lang) as any[],
        isLoadingCatalogs,
        error,
        refresh: fetchCatalogs 
    };
};import {useCallback, useEffect, useState} from "react";
import {API, Endpoints} from "@brg/api";


export const useGetCatalogs = (service: string, userId: string | null, allowNoProfile?: boolean, disabled?: boolean, lang: string = 'en'
) => {

    const [catalogs, setCatalogs] = useState<any>(undefined);
    const [subCollections, setSubCollections] = useState<any[]>([]);
    const [isLoadingCatalogs, setIsLoadingCatalogs] = useState<boolean>(false);
    const [error, setError] = useState<boolean>(false);

    const fetchCatalogs = useCallback(() => {
        if (disabled) {
            return;
        }
        setIsLoadingCatalogs(true);
        const apiRequest = userId
            ? API.request()
                .endpoint(Endpoints.cardsMnePw)
                .url('/api/Collection/GetCatalogs')
                .addQuery('service', service)
                .addQuery('userId', userId)
                .addQuery('exceptForSelectors', 'true')
                .get()
            : API.request()
                .endpoint(Endpoints.cardsMnePw)
                .url('/api/Collection/GetCatalogs')
                .addQuery('service', service)
                .addQuery('exceptForSelectors', 'true')
                .get()
        apiRequest
            .send()
            .then((r) => r.json())
            .then((r) => {
                setIsLoadingCatalogs(false);
                setCatalogs(r)
                const allSubCollections = r?.flatMap((catalog: any) => 
                    catalog.subCollections?.map((sub: any) => ({
                        ...sub,
                        catalogId: catalog.cardCollectionId
                    })) || []);
                setSubCollections(allSubCollections)
            })
            .catch((e) => {
                setIsLoadingCatalogs(false);
                setError(true)
            });
    }, [userId, service])

    useEffect(() => {
        if ((userId || allowNoProfile) && service) {
            fetchCatalogs()
        }
    }, [userId, service, allowNoProfile, fetchCatalogs])

    return {
        catalogs: API.toLang(catalogs, lang) as any,
        subCollections: API.toLang(subCollections, lang) as any[],
        isLoadingCatalogs,
        error,
        refresh: fetchCatalogs 
    };
};